import React, { useState, useEffect } from 'react';
import { tickFormat } from 'd3';
import { Graph } from '../generalPlot/Graph';
import { Marks} from './Marks';
import { AxisLeft } from './AxisLeft';
import { AxisBottom } from './AxisBottom';


const margin = {top: 50, left: 50, bottom: 50, right: 20};


const Tooltip = ( {visible, x, y, lipid, probability, width, height} ) => {
  const labelWidth=150;
  const labelHeight=50;
  const labelYOffset=10;

  const xpos = Math.max(labelWidth/2, Math.min(x, width-labelWidth/2));
  const ypos = (y - labelHeight - labelYOffset < 0) ? y + labelHeight + labelYOffset * 2 : y;

  if (visible) {
    return (
      <g transform={`translate(${xpos-labelWidth/2},${ypos-labelHeight-labelYOffset})`}>
        <rect 
          className="tooltip"
          width={labelWidth} height={labelHeight}
          style={{opacity: 0.9, fill: "white", stroke: "#653f4d", strokeWidth: 2}}
        />
        <text x={labelWidth/2} y={labelHeight/2} dy=".3em" style={{textAnchor: "middle"}}>
          <tspan className="text-main"
            style={{fontWeight: "bold", fill: "#653f4d"}}
          >{lipid}</tspan>
          <tspan className="text-light" dx="0.5em"
            style={{fill: "#8e8883"}}
          >{probability}</tspan>
        </text>
      </g>
    )
  }
  return <></>
};


export const DotPlot = ( {data, width, height, xScale, yScale, r, color, title, setSelectedLipid }) => {
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  const x = xScale
    .range([0, innerWidth])
    .nice();

  const y = yScale
    .range([innerHeight, 0])
    .nice();
  
  const [clicked, setClicked] = useState(false);
  const [tooltip, setTooltip] = useState({
    visible: false, x:0, y: 0, lipid: "", probability: "",
  });
  const formatter = tickFormat(0, 1, 5, ".2%");

  useEffect(() => {
    if (clicked) {
      setSelectedLipid(tooltip.lipid);
    }
    else {
      setSelectedLipid(null);
    }
  }, [clicked]);

  const handleMouseEnter = (event, d) => {
    if (!clicked) {
      setTooltip({
        visible: true,
        x: x(d.cc), 
        y: y(d.db), 
        lipid: d.lipid,
        probability: formatter(d.probability)
      })
    }
  };
  const handleMouseLeave = () => {
    if (!clicked) {
      setTooltip({visible: false, x:0, y:0, content: ""})
    }
  };

  return (
    <Graph
      width={width}
      height={height}
      margin={margin}
    >
      <text 
        className="plot-title"
        x={innerWidth / 2} y={-15} textAnchor="middle">{title}</text>
      <AxisBottom 
        x={x}
        innerHeight={innerHeight}
      />
      <text 
        className="axis-label"
        x={innerWidth / 2} y={innerHeight + 35} textAnchor="middle">Carbon chain length / #</text>
      <AxisLeft
        y={y}
        innerWidth={innerWidth}
      />
      <text 
        className="axis-label"
        transform={`translate(-35,${innerHeight/2}) rotate(-90)`}
        textAnchor="middle">Double bonds / #</text>
      <Marks
        data={data}
        x={x}
        y={y}
        r={r}
        color={color}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        hoveredLipid={tooltip.lipid}
        onClick={() => setClicked(!clicked)}
      />
      <Tooltip
        visible={tooltip.visible}
        x={tooltip.x}
        y={tooltip.y}
        lipid={tooltip.lipid}
        probability={tooltip.probability}
        width={innerWidth}
        height={innerHeight}
      />
    </Graph>
  );
};
